
















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { Home } from "@/shared/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useUserStore } from "@/shared/store/user";

@Component ({
  components: {
    GenericLoadingSpinner
  }
})
export default class SsoValidateAccount extends Vue {
  userStore = useUserStore();

  @Prop() token: string;

  mounted (): void {

    if (this.userStore.loggedIn && !this.token) {
      this.$router.push({ name: Home });
      return;
    }

    this.$router.push({name: LoginRouteNames.Login});
  }

@Watch("userStore.loggedIn")
  watchLoggedIn (): void {
    if (this.userStore.loggedIn) {
      this.$router.push({ name: Home });
    }
  }
}
